import React, { ReactNode } from "react"
import {
  Flex, FlexProps, HStack, Text, VisuallyHidden,
} from "@chakra-ui/react"

const FloatingToolbar = ({ children, ...props }: FlexProps) => (
  <Flex
    align="center"
    justify="space-between"
    gap={6}
    minH={12}
    pl={6}
    pr={2}
    py={1}
    bg="white"
    borderWidth={1}
    borderColor="gray.200"
    borderRadius="full"
    sx={{ "& .chakra-button": { borderRadius: "full" } }}
    {...props}
  >
    {children}
  </Flex>
)

type FieldProps = {
  label: string
  hideLabel?: boolean
  children: ReactNode
}

export const FloatingToolbarField = ({ label, hideLabel, children }: FieldProps) => (
  <HStack spacing={2}>
    {hideLabel
      ? <VisuallyHidden>{label}</VisuallyHidden>
      : <Text as="span" fontWeight="semibold" whiteSpace="nowrap">{label}</Text>}
    {children}
  </HStack>
)

export default FloatingToolbar
